import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'ng-casto-card-marketing',
  templateUrl: './card-marketing.component.html',
})
export class CardMarketingComponent {
  @ContentChild('headerTemplate') headerTemplate: TemplateRef<any>;
  @ContentChild('bodyTemplate') bodyTemplate: TemplateRef<any>;
  @ContentChild('footerTemplate') footerTemplate: TemplateRef<any>;

  @Input() imageSrc: string;

  protected hasCustomTemplate(templateRef: TemplateRef<any>): boolean {
    return !!templateRef;
  }
}
